import script from "./UserInquiryDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserInquiryDialog.vue?vue&type=script&setup=true&lang=ts"

import "./UserInquiryDialog.vue?vue&type=style&index=0&id=65d78caf&lang=scss"

const __exports__ = script;

export default __exports__